module.exports = __webpack_public_path__ + "static/EG-intyg-EN-1090-1-59ea261c6e69bf4d7a70ca0f5c4b934d.pdf";